"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInitChannels = useInitChannels;
var _react = require("react");
var _lodash = require("lodash");
var _ = require("./..");
var _shared = require("../../shared");
var _queryService = require("./queryService");
var _constants = require("../constants");
var _useUnreadCommunityFavicon = require("./useUnreadCommunityFavicon");
var _useChannelsUnread2 = require("./useChannelsUnread");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function useInitChannels(_ref) {
  var client = _ref.client,
    chatUser = _ref.chatUser;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    isChatAllowed = _useState2[0],
    setIsChatAllowed = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    loadingChannels = _useState4[0],
    setLoadingChannels = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    channels = _useState6[0],
    setChannels = _useState6[1];
  var _useChannelsUnread = (0, _useChannelsUnread2.useChannelsUnread)({
      client: client,
      channels: channels
    }),
    unreadMessages = _useChannelsUnread.unreadMessages,
    unreadMentions = _useChannelsUnread.unreadMentions;
  (0, _useUnreadCommunityFavicon.useUnreadCommunityFavicon)({
    unreadMentions: unreadMentions,
    unreadMessages: unreadMessages
  });
  (0, _react.useEffect)(function () {
    if (!client || !chatUser) {
      return;
    }
    var initChannels = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var client, chatUser, _yield$Promise$all, _yield$Promise$all2, oneToOneChannels, communityChannels, groupChannels;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                client = _ref2.client, chatUser = _ref2.chatUser;
                setLoadingChannels(true);
                _context.next = 4;
                return Promise.all([_queryService.chatQueryService.queryChannels({
                  client: client,
                  filter: _queryService.chatQueryService.getChatMembersFilter({
                    type: _constants.MESSAGING_CHAT_CHANNEL_TYPE,
                    members: [chatUser.me.id]
                  }),
                  // when sort by the last message empty channels are not returned
                  sort: {},
                  // default limit is 10 but there may be more channels. max is 30
                  options: {
                    limit: 3000,
                    watch: true
                  }
                }), _queryService.chatQueryService.queryChannels({
                  client: client,
                  filter: _queryService.chatQueryService.getChatMembersFilter({
                    type: {
                      $in: (0, _lodash.values)(_constants.COMMUNITY_CHANNEL_TYPES)
                    },
                    disabled: false
                  }),
                  sort: {},
                  options: {
                    limit: 3000,
                    watch: true
                  }
                }), _queryService.chatQueryService.queryChannels({
                  client: client,
                  filter: _queryService.chatQueryService.getChatMembersFilter({
                    type: {
                      $in: (0, _lodash.values)(_constants.SUPPORT_GROUP_CHANNEL_TYPES)
                    },
                    disabled: false
                  }),
                  sort: {},
                  options: {
                    limit: 3000,
                    watch: true
                  }
                })]);
              case 4:
                _yield$Promise$all = _context.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
                oneToOneChannels = _yield$Promise$all2[0];
                communityChannels = _yield$Promise$all2[1];
                groupChannels = _yield$Promise$all2[2];
                setChannels({
                  oneToOne: oneToOneChannels,
                  community: communityChannels,
                  group: groupChannels
                });
                setIsChatAllowed(!!(oneToOneChannels !== null && oneToOneChannels !== void 0 && oneToOneChannels.length));
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function initChannels(_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    if (client && isChatAllowed === undefined && loadingChannels === undefined) {
      (0, _.retry)(function () {
        return initChannels({
          client: client,
          chatUser: chatUser
        });
      }).catch(function (err) {
        (0, _shared.trackUserEvent)({
          eventName: 'Getstream Chat Error',
          eventValues: {
            error: (0, _.stringifyError)(err),
            message: err === null || err === void 0 ? void 0 : err.message
          }
        });
      }).finally(function () {
        return setLoadingChannels(false);
      });
    }
  }, [client, chatUser]);
  return {
    channels: channels,
    isChatAllowed: isChatAllowed,
    loadingChannels: loadingChannels,
    unreadMessages: unreadMessages,
    unreadMentions: unreadMentions
  };
}